module.exports = __webpack_public_path__ + "static/media/trump_face.42494c71.svg";